import { Box, makeStyles } from "@material-ui/core";
import React, { Fragment } from "react";
import newsData from "../data/NewsData";
import LongButton from "./LongButton";

const useStyles = makeStyles((theme) => ({
  sidebar: {
    width: "100%",
    height: "100%",

    backgroundColor: "rgb(255,255,255)",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    padding: "40px 0",
    // display: "flex",
  },
  button: {
    width: "100%",
    height: "80px",
    marginLeft: "25px",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px",
    fontWeight: "bold",
    fontSize: "18px",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    backgroundColor: "white",
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "12px",

      marginLeft: "20px",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "9px",
      width: "105%",
      marginLeft: "20px",
    },
  },
  buttonActive: {
    width: "100%",
    height: "80px",
    backgroundColor: theme.palette.primary.main,
    marginBottom: "20px",
    fontWeight: "bold",
    fontSize: "18px",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "12px",
    },
  },
  buttonLogo: {
    marginRight: "10px",
  },
}));
export default function Sidebar({ setTabButton }) {
  const classes = useStyles();
  return (
    <Box className={classes.sidebar}>
      {newsData.map((btn) => {
        return (
          <Fragment key={btn.id}>
            <LongButton
              title={btn.title}
              img={btn.img}
              setTab={() => setTabButton(btn.id)}
              buttonStyle={classes.button}
              imgStyle={classes.buttonLogo}
            />
          </Fragment>
        );
      })}
    </Box>
  );
}
